var render = function render(){var _vm=this,_c=_vm._self._c;return _c('orders-base-view',{attrs:{"status":"canceled"}})
}
var staticRenderFns = []

export { render, staticRenderFns }